<!-- src/components/projects/ProjectTabs.vue -->
<template>
  <div class="project-tabs-container">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="title">Editar Projeto</h3>
      <ul class="nav nav-tabs" id="projectTabs" role="tablist">
        <!-- Botão de Voltar -->
        <li class="nav-item" role="presentation">
          <button
            @click="$router.back()"
            class="nav-link btn-back"
            title="Voltar"
          >
            <i class="fas fa-arrow-left me-1"></i> Voltar
          </button>
        </li>

        <!-- Abas de navegação -->
        <li
          class="nav-item"
          role="presentation"
          v-for="tab in tabs"
          :key="tab.name"
        >
          <button
            class="nav-link"
            :class="{ active: activeTab === tab.name }"
            :id="`${tab.name}-tab`"
            @click="selectTab(tab.name)"
            type="button"
            role="tab"
            :aria-controls="`${tab.name}-tab-pane`"
            :aria-selected="activeTab === tab.name"
          >
            <i :class="getTabIcon(tab.name)" class="me-1"></i> {{ tab.label }}
          </button>
        </li>
      </ul>
    </div>

    <div class="tab-content" id="projectTabsContent">
      <component
        v-if="activeTab"
        :is="activeComponent"
        class="tab-pane fade show active"
        role="tabpanel"
        :aria-labelledby="`${activeTab}-tab`"
        :project="project"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useProjectStore } from "@/stores/projectStore";
import { useRoute } from "vue-router";

import Summary from "./Summary";
import Locations from "./Locations";
import Ambients from "./Ambients";
import Boxes from "./Boxes";
import Panels from "./Panels";

export default {
  components: {
    Summary,
    Locations,
    Ambients,
    Boxes,
    Panels,
  },
  setup() {
    const projectStore = useProjectStore();
    const route = useRoute();
    const projectId = route.params.projectId;
    const project = ref(null);
    const activeTab = ref("summary");

    const fetchProject = async () => {
      project.value = await projectStore.getProject(projectId); // Fetch project from store
    };

    onMounted(() => {
      fetchProject(); // Fetch project when the component mounts
    });

    // Array de abas
    const tabs = ref([
      { name: "summary", label: "Resumo" },
      { name: "locations", label: "Local" },
      { name: "ambients", label: "Ambientes" },
      { name: "boxes", label: "Caixas" },
      { name: "panels", label: "Quadros" },
    ]);

    const activeComponent = computed(() => {
      const componentName =
        activeTab.value.charAt(0).toUpperCase() + activeTab.value.slice(1);
      return componentName;
    });

    const selectTab = (tab) => {
      activeTab.value = tab;
    };

    const getTabIcon = (tabName) => {
      switch (tabName) {
        case "summary":
          return "fas fa-info-circle";
        case "locations":
          return "fas fa-map-marker-alt";
        case "ambients":
          return "fas fa-building";
        case "boxes":
          return "fas fa-box";
        case "panels":
          return "fas fa-columns";
        default:
          return "fas fa-folder";
      }
    };

    return {
      project,
      tabs,
      activeTab,
      activeComponent,
      selectTab,
      getTabIcon,
    };
  },
};
</script>

<style scoped>
.nav-tabs {
  margin-bottom: 10px;
}

.nav-tabs .nav-item {
  margin-right: 10px;
}

.nav-tabs .nav-link {
  color: #495057;
  padding: 10px 15px;
  border-radius: 5px;
  background-color: #e9ecef;
  font-weight: 500;
}

.nav-tabs .nav-link.active {
  background-color: #007bff;
  color: #fff;
}

.tab-content {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}

.tab-pane {
  transition: opacity 0.3s ease;
}
</style>
